import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './Dialog';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './Tabs';
import { GithubImportTab } from './GithubImportTab';
import { LocalImportTab } from './LocalImportTab';
import styles from './ImportFilesDialog.module.css';

interface ImportFilesDialogProps {
  sessionId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ImportFilesDialog: React.FC<ImportFilesDialogProps> = ({
  sessionId,
  open,
  onOpenChange,
}) => {
  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={styles.dialogContent}>
        <DialogHeader>
          <DialogTitle>Import Files</DialogTitle>
        </DialogHeader>

        <Tabs defaultValue="github" className={styles.tabs}>
          <TabsList className={styles.tabsList}>
            <TabsTrigger value="github">From GitHub</TabsTrigger>
            <TabsTrigger value="upload">Upload Files</TabsTrigger>
          </TabsList>

          <TabsContent value="github" className={styles.tabContent}>
            <GithubImportTab sessionId={sessionId} onClose={() => onOpenChange(false)} />
          </TabsContent>

          <TabsContent value="upload" className={styles.tabContent}>
            <LocalImportTab sessionId={sessionId} onClose={() => onOpenChange(false)} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
